import React from "react"

export const withPagination = Component => ({ name = "Pagination", totalPageCount, currentPage, handlePageChange }) => {
  Component.displayName = name
  return <Component count={totalPageCount} page={currentPage} handleChange={handlePageChange} />
}
